import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LobbyCentralViewsRoutingModule } from './lobby-central-views-routing.module';
import { LobbyCentralViewsComponent } from './lobby-central-views.component';
import { LobbyCentralLocationViewComponent } from './lobby-central-location-view/lobby-central-location-view.component';
import { LobbyCentralViewComponent } from './lobby-central-staff-status-view/lobby-central-staff-status-view.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LobbyCentralViewsLocationSelectorComponent } from './lobby-central-views-location-selector/lobby-central-views-location-selector.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LobbyCentralViewEffects } from './state/lobby-central-view.effects';
import { LobbyCentralLobbyViewComponent } from './lobby-central-lobby-view/lobby-central-lobby-view.component';
import { reducers } from './state/redusers';
import { CdTimerModule } from 'angular-cd-timer';
import { SharedModule } from 'src/app/shared/shared.module';
import { ImpersonateAssistComponent } from 'src/app/lobby/lobby-central-views/shared/impersonate-assist/impersonate-assist.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppTimerModule } from '../../shared/layout/app-layout/app-timer/app-timer.module';

@NgModule({
  declarations: [
    LobbyCentralViewsComponent,
    LobbyCentralLobbyViewComponent,
    LobbyCentralLocationViewComponent,
    LobbyCentralViewComponent,
    LobbyCentralViewsLocationSelectorComponent,
    ImpersonateAssistComponent

  ],
  imports: [ 
    CommonModule,
    GridModule,
    FormsModule,
    DialogModule,
    SharedModule,
    NgMultiSelectDropDownModule,
    ReactiveFormsModule,
    NgbModule,
    CdTimerModule,
    StoreModule.forFeature('lobbyCentralView', reducers),
    EffectsModule.forFeature([LobbyCentralViewEffects]),
    InputsModule,
    LobbyCentralViewsRoutingModule,
    AppTimerModule,
    TranslateModule
  ],
  exports: [
    LobbyCentralViewsComponent,
    TranslateModule
  ],
})
export class LobbyCentralViewsModule { }
